export default __webpack_public_path__ + "static/media/help.53f3843c.svg";